import * as React from 'react'
import MilitarySkillsTranslator from '../assets/imgs/spotlight/MilitarySkillsTranslator.png'
import LearningIntegrations from '../assets/imgs/spotlight/LearningIntegrations.png'
import GovernmentEducationClients from '../assets/imgs/spotlight/GovernmentEducationClients.png'
import PAMHealth from '../assets/imgs/spotlight/PAMHealth.png'
import BlackstoneHPA from '../assets/imgs/spotlight/BlackstoneHPA.png'
import FloridaInternationalUniversity from '../assets/imgs/spotlight/FloridaInternationalUniversity.png'
import TrademarkText from '../components/ui/TrademarkText'

export const SpotlightData = [
  {
    src: MilitarySkillsTranslator,
    alt: 'Pod Matching Engine in Action',
    title: (
      <>
        <TrademarkText>Pod Matching Engine™</TrademarkText> in Action
      </>
    ),
    description: (
      <>
        Translating military experience into civilian career pathways using
        skills intelligence powered by{' '}
        <TrademarkText>Pod Intelligence Core™</TrademarkText>.
      </>
    ),
  },
  {
    src: PAMHealth,
    alt: 'Workforce Transition Intelligence',
    title: 'Workforce Transition Intelligence',
    description: (
      <>
        Powered by <TrademarkText>Pod Intelligence Core™</TrademarkText> and{' '}
        <TrademarkText>Pod Matching Engine™</TrademarkText> to support workforce
        mobility during organisational change.
      </>
    ),
  },
  {
    src: FloridaInternationalUniversity,
    alt: 'University Career Intelligence',
    title: 'University Career Intelligence',
    description: (
      <>
        Powered by <TrademarkText>Pod Intelligence Core™</TrademarkText> to
        enable real-time internship discovery and skills-based matching for
        student populations.
      </>
    ),
  },
  {
    src: GovernmentEducationClients,
    alt: 'Trusted Deployments of Pod Intelligence Core',
    title: (
      <>
        Trusted Deployments of{' '}
        <TrademarkText>Pod Intelligence Core™</TrademarkText>
      </>
    ),
    description:
      'Supporting government, defense, and university workforce intelligence initiatives worldwide.',
  },
  {
    src: LearningIntegrations,
    alt: 'Learning Intelligence Integrations',
    title: 'Learning Intelligence Integrations',
    description: (
      <>
        Powered by <TrademarkText>Pod Intelligence Core™</TrademarkText> to link
        learning, skills, and career outcomes in real time.
      </>
    ),
  }
]

export const SWIPE_THRESHOLD = 60
